import React, { Component } from "react";
import logo from "../static/img/logo.png";
import { animateScroll as scroll } from "react-scroll";
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import { getText } from "../Text";
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom'

export default class Header extends Component {

	scrollToTop = () => {
		scroll.scrollToTop();
	};

	onLanguageChange = (country) => {
		const changeLanguage = this.props.changeLanguage
		changeLanguage(country)
	}

	render() {

		return (
			<Navbar collapseOnSelect expand="lg" bg="light" variant="light" sticky="top">
				<Navbar.Brand as={Link} to="/">
					<img
						src={logo}
						className="nav-logo"
						alt="Logo"
						onClick={this.scrollToTop}
					/>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="mr-auto">
						<Nav.Link as={Link} to="/">{getText(this.props.language).header.section_1}</Nav.Link>
						<Nav.Link as={Link} to="/inspection-flow">{getText(this.props.language).header.section_2}</Nav.Link>
						<Nav.Link as={Link} to="/past-projects">{getText(this.props.language).header.section_3}</Nav.Link>
						<Nav.Link as={Link} to="/contact">{getText(this.props.language).header.section_4}</Nav.Link>
					</Nav>
					<ReactFlagsSelect
						defaultCountry="CN"
						countries={["CN", "US"]}
						customLabels={{ "US": "EN", "CN": "中文" }}
						onSelect={this.onLanguageChange}
						className="flag-select"
					/>
				</Navbar.Collapse>
			</Navbar>
		);
	}
}
